const isMaintenanceError = (error) =>
  error && /#503 Maintenance flag/.test(error.message);

export default isMaintenanceError;
